import { BankAccountApi } from "@/api/BankAccountApi";
import { CreditOperatorApi } from "@/api/CreditOperatorApi";
import { EDITOR_INPUT, RADIO_INPUT_TYPE, SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";
import { CARD_PAYMENT_WAY_CODE, CHEQUE_PAYMENT_WAY_CODE, DIGITAL_PLATFORM_PAYMENT_WAY_CODE, SINPE_PAYMENT_WAY_CODE, TAXES_PERCENTAGES, TAXES_TYPES, TRANSFER_PAYMENT_WAY_CODE } from "@utils/Constants";
import { generatePaymentWayOptions } from "@utils/EDocument";
import { generateSelectOption } from "@utils/Utils";

const ChangeProductTaxFormConfig = {
    submit: {
        label: "Actualizar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "taxType",
                        "label": "Tipo de Impuesto",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "options": generateSelectOption(TAXES_TYPES),
                        "validation": Yup.string().required("Este campo es requerido"),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "taxPercentage",
                        "label": "Porcentaje de Impuesto",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "options": generateSelectOption(TAXES_PERCENTAGES),
                        "validation": Yup.string().required("Este campo es requerido"),
                    }
                ],
            ]
        }
    ],
};


export default ChangeProductTaxFormConfig;